import Collaborators from "./Collaborators";

export default Collaborators;



// WEBPACK FOOTER //
// ./src/components/Collaborators/index.js